import { render, staticRenderFns } from "./LclText.vue?vue&type=template&id=5b8e480b&scoped=true"
import script from "./LclText.vue?vue&type=script&lang=js"
export * from "./LclText.vue?vue&type=script&lang=js"
import style0 from "./LclText.vue?vue&type=style&index=0&id=5b8e480b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e480b",
  null
  
)

export default component.exports